import {
    SETING_CONTRACT_GET_ALL,
} from '../constants/ActionTypes'

const initialState = {
    data: [],
    pointRatio: [],
    menuPremiumExist: false,
}

export const SettingContractTerm = (state = initialState, action) => {
    switch (action.type) {
      
        case SETING_CONTRACT_GET_ALL:
            return  { ...state, data: action.data };
        default:
            return state
    }
}
